import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ToastService {
  isVisible = signal<boolean>(false);
  message = signal<string>('');
  class = signal<string>('alert-alert');
  constructor() {}

  setMessage(message: string, css: string = 'alert-alert') {
    this.message.set(message);
    this.class.set(css);
  }

  show() {
    this.isVisible.set(true);
  }

  hide() {
    this.isVisible.set(false);
  }
}
